angular.module('List', ['ui.select', 'ngRoute', 'ui.tree', 'ui.tree-filter']);

angular.module('List').config(['$routeProvider',
    function($routeProvider) {
        $routeProvider.
            when('/indikatoren', {
                templateUrl: templatePath+'IndicatorList.html',
                controller: 'IndicatorListController'
            }).
            when('/indikatoren-bereiche', {
                templateUrl: templatePath+'CategoryList.html',
                controller: 'CategoryListController'
            }).
            when('/indikatoren-sets', {
                templateUrl: templatePath+'IndicatorTypeList.html',
                controller: 'IndicatorTypeListController'
            }).
            when('/indikatoren-baum', {
                templateUrl: templatePath+'IndicatorTree.html',
                controller: 'IndicatorTreeController'
            }).
            otherwise({
                redirectTo: '/indikatoren-baum'
            });
    }
]);

// delete Cache
localStorage.removeItem('hyperionIndicatorList');
localStorage.removeItem('hyperionIndicatorTypeList');
localStorage.removeItem('hyperionIndicatorCategoryList');
localStorage.removeItem('hyperionIndicatorTree');
